var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7954 18.6786L6.6742 40.7693C6.43438 40.9889 6.06539 40.7234 6.19742 40.4262L13.3494 24.3293C13.4375 24.1309 13.2923 23.9075 13.0752 23.9075H2.55378C2.31475 23.9075 2.17172 23.6416 2.30345 23.4421L16.3408 2.18959C16.5259 1.90933 16.8393 1.74072 17.1752 1.74072H34.0486C34.3085 1.74072 34.4454 2.04873 34.2713 2.2417L20.362 17.6564C20.1879 17.8494 20.3248 18.1574 20.5847 18.1574H30.5928C30.8665 18.1574 30.9972 18.4938 30.7954 18.6786Z",
    stroke: "#F74F38",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList2);
export default __webpack_public_path__ + "static/media/list_2.b3b414e4b45b8f0592452e8c941498d6.svg";
export { ForwardRef as ReactComponent };